import type { JSX } from 'react';
import { Accordion, AccordionContent, AccordionHeader, AccordionItem, AccordionTrigger } from '@c2fo/liquidity';
import { FAQS_CONTENT } from '@/enterprise/features/extendedNetworkFinance/content/sharedContent';

const Faqs = (): JSX.Element => (
  <div className="flex flex-col items-center space-y-8">
    <p className="text-center text-3xl">{FAQS_CONTENT.title}</p>
    <Accordion type="multiple" className="grid w-full grid-cols-1 gap-8 md:grid-cols-2">
      {FAQS_CONTENT.items.map((faq) => (
        <AccordionItem key={faq.question} value={faq.question} className="max-h-fit rounded-2xl bg-white p-4 shadow-md">
          <AccordionHeader className="flex justify-between space-x-6">
            <p className="text-lg font-medium">{faq.question}</p>
            <AccordionTrigger />
          </AccordionHeader>
          <AccordionContent className="px-6">
            <p className="text-text-secondary">{faq.answer}</p>
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
    <p className="text-center text-xs italic text-text-secondary">{FAQS_CONTENT.disclaimer}</p>
  </div>
);

export default Faqs;
